import { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.jsx'
import { useToast } from '../context/ToastContext.jsx'
import ConfigNotice from '../components/ConfigNotice.jsx'
import Seo from '../components/Seo.jsx'

export default function Login() {
  const { login, isConfigured } = useAuth()
  const toast = useToast()
  const navigate = useNavigate()
  const location = useLocation()
  const dest = location.state?.from || '/calculator'
  // Carry a calc from the result-moment signup prompt back to the calculator.
  const pendingCalc = location.state?.calc

  const [form, setForm] = useState({ email: '', password: '' })
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    const res = await login(form)
    setBusy(false)
    if (res.error) return setError(res.error)
    toast(`Welcome back, ${res.user.name}`, 'green')
    navigate(dest, { replace: true, state: pendingCalc ? { calc: pendingCalc } : undefined })
  }

  return (
    <main className="page">
      <Seo title="Log in | CalculateMyPeptides" noindex />
      <div className="container auth-wrap">
        <div className="card auth-card fade-in">
          <div className="auth-head">
            <h1>Log in</h1>
            <p>Access your saved calculations and calendar.</p>
          </div>
          {!isConfigured && <ConfigNotice />}
          <form onSubmit={submit}>
            <div className="field">
              <label className="label">Email</label>
              <input className="input" type="email" autoComplete="email" required
                value={form.email} onChange={set('email')} placeholder="you@example.com" />
            </div>
            <div className="field">
              <label className="label label-row">
                <span>Password</span>
                <Link to="/forgot-password" className="label-link">Forgot password?</Link>
              </label>
              <input className="input" type="password" autoComplete="current-password" required
                value={form.password} onChange={set('password')} placeholder="••••••••" />
            </div>
            {error && <div className="form-error" style={{ marginBottom: 12 }}>{error}</div>}
            <button className="btn btn-primary btn-block" type="submit" disabled={busy}>
              {busy ? 'Logging in…' : 'Log in'}
            </button>
          </form>
          <div className="auth-foot">
            No account? <Link to="/register">Create one free</Link>
          </div>
        </div>
        <p className="muted small center" style={{ marginTop: 14 }}>
          Your saved calculations and calendar are private to your account.
        </p>
      </div>
    </main>
  )
}
